module.exports = __webpack_public_path__ + "images/9b9873b273322a6649c039ea15f91741-platinum.png";